import { render, staticRenderFns } from "./CampaignsMessagesView.vue?vue&type=template&id=7411a728&"
import script from "./CampaignsMessagesView.vue?vue&type=script&lang=js&"
export * from "./CampaignsMessagesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports